import React from 'react';
import agreementIcon from './assets/icons/agreement-icon.png';
import analyticsIcon from './assets/icons/analytics-icon.png';
import bankIcon from './assets/icons/bank-icon.png';
import logo from './assets/branding/company-logo.png';

const OurValuesSection = ({ isArabic }) => {
  const text = {
    en: {
      subtitle: "OUR VALUES",
      title: "Our Values",
      features: [
        {
          title: "Integrity and transparency",
          description: "Commitment to transparency and professional standards in all our services.",
          icon: agreementIcon
        },
        {
          title: "Compliance with laws and regulations",
          description: "Full adherence to applicable laws and regulations in all operations.",
          icon: bankIcon
        },
        {
          title: "Protection of clients' funds and data",
          description: "Ensuring the highest level of security for client assets and information.",
          icon: analyticsIcon
        },
        {
          title: "Quality in service delivery",
          description: "Delivering exceptional service quality that exceeds expectations.",
          icon: agreementIcon
        },
        {
          title: "Continuous development",
          description: "Constantly improving our services and capabilities to serve you better.",
          icon: bankIcon
        }
      ]
    },
    ar: {
      subtitle: "قيمنا",
      title: "قيمنا",
      features: [
        {
          title: "النزاهة والشفافية",
          description: "الالتزام بالشفافية والمعايير المهنية في جميع خدماتنا.",
          icon: agreementIcon
        },
        {
          title: "الالتزام بالقوانين واللوائح",
          description: "الالتزام الكامل بالتشريعات والأنظمة المعمول بها.",
          icon: bankIcon
        },
        {
          title: "حماية أموال وبيانات العملاء",
          description: "ضمان أعلى مستوى من الأمان لأصول ومعلومات العملاء.",
          icon: analyticsIcon
        },
        {
          title: "الجودة في تقديم الخدمات",
          description: "تقديم جودة خدمة استثنائية تفوق التوقعات.",
          icon: agreementIcon
        },
        {
          title: "التطوير المستمر",
          description: "التحسين المستمر لخدماتنا وقدراتنا لخدمتكم بشكل أفضل.",
          icon: bankIcon
        }
      ]
    }
  };

  const currentLang = isArabic ? 'ar' : 'en';

  return (
    <section className="py-8 sm:py-10 lg:py-12" style={{backgroundColor: '#FAFAFA'}}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-6 sm:gap-8 lg:gap-12 items-center">
          {/* Left side - Content */}
          <div className="w-full lg:w-[50%]">
            <div className="mb-4 sm:mb-5">
              <p className="text-xs font-semibold tracking-wider uppercase mb-2" style={{color: '#006655'}}>
                {text[currentLang].subtitle}
              </p>
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-black leading-tight mb-4 sm:mb-5">
                {text[currentLang].title}
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-5">
              {text[currentLang].features.map((feature, index) => (
                <div key={index} className="bg-white rounded-lg p-3 sm:p-4 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 ${isArabic ? 'mb-3 sm:mb-4' : 'mb-2 sm:mb-3'} flex items-center justify-center rounded-lg`} style={{backgroundColor: '#F0F9F7'}}>
                    <img 
                      src={feature.icon} 
                      alt={feature.title}
                      className="w-6 h-6 sm:w-7 sm:h-7 object-contain"
                    />
                  </div>
                  <h3 className="text-sm sm:text-base font-bold text-black mb-1 sm:mb-1.5">
                    {feature.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right side - Icon Display */}
          <div className="w-full lg:w-[50%]">
            <div className="relative flex items-center justify-center h-[300px] sm:h-[400px] lg:h-[550px]">
              {/* Background square */}
              <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-3xl opacity-10" style={{backgroundColor: '#006655'}}></div>
              {/* Logo */}
              <div className="relative z-10 w-48 h-48 sm:w-64 sm:h-64 lg:w-80 lg:h-80 rounded-3xl flex items-center justify-center" style={{backgroundColor: '#006655'}}>
                <img 
                  src={logo} 
                  alt="Company Logo" 
                  className="w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 object-contain filter brightness-0 invert"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurValuesSection;